import React from 'react'
import { useUserStore } from '../stores/UserStore'
import { useUserAdminPresencial } from '../stores/UserAdminPresencial';
import { Link } from 'react-router-dom'
import { Container, Nav, Navbar, Dropdown } from 'react-bootstrap';
import { useUserAdminStore } from '../stores/userAdmin';

const Navbarmenu = ({user, setUser}) => {
    const cerrarSesion =(e)=>{
        e.preventDefault();
        setUser({
            error: false,
            login:false,
            name_user: '',
            token_user: '',
            errorMsg: ''
          })        

    }
    const cerrarSesionAdmin =(e)=>{
      e.preventDefault();
      logout()        

  }

  const cerrarSesionPresencial = (e) => {
    e.preventDefault();
    closeUserAdminPresencial()
  }

  const userGlobal = useUserStore((state) => state.userGlobal)
  const updateUser = useUserStore((state) => state.updateUser)
  const userAdminPresencial = useUserAdminPresencial((state) => state.userAdminPresencial)
  const updateUserAdminPresencial = useUserAdminPresencial((state) => state.updateUserAdminPresencial)
  const closeUserAdminPresencial = useUserAdminPresencial((state) => state.closeUserAdminPresencial)
  const { userAdmin, logout } = useUserAdminStore();

  return (
      <Navbar expand="lg" bg="light" variant="light">
          <Container>
              <Navbar.Brand as={Link} to="/">
                  <img
                      src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/Presupuesto-Participativo02.png"
                      width="200"
                      className="d-inline-block align-top"
                      alt="Municipalidad de Trenque Lauquen"
                  />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto">
                      <Nav.Link href="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/Reglamento-definitivo-PP-y-PP-JOVEN.pdf" target="_blank">Reglamento</Nav.Link>
                      <Nav.Link href="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/O5306-E4284-Presupuesto-Participativo-en-todas-las-localidades-del-Distrito-de-T.-Lauquen-y-PPJoven.pdf" target="_blank">Ordenanza 5306/2022</Nav.Link>
                      {userAdmin.login && (
                          <>
                              <Nav.Link as={Link} to="/paneladmin">Panel de Administracion</Nav.Link>                              
                          </>
                      )}
                  </Nav>
                  {(user.login || userAdmin.login) && (
                      <Nav>
                          {user.login && (
                              <Navbar.Text>
                                  Bienvenido <strong>{user.name_user}</strong> | <a href="#" onClick={cerrarSesion}>Cerrar sesión</a>
                              </Navbar.Text>
                          )}
                          {userAdmin.login && (
                              <Navbar.Text>
                                  Bienvenido Admin <strong>{userAdmin.name_user}</strong> | <a href="#" onClick={cerrarSesionAdmin}>Cerrar sesión</a>
                              </Navbar.Text>
                          )}
                      </Nav>
                  )}
                  {userAdminPresencial.login ? (
                      <Dropdown align="end">
                          <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                              <i className="bi bi-credit-card-2-front"></i> {userAdminPresencial.legajo}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                              <Dropdown.Item><i className="bi bi-person-fill-gear"></i> {userAdminPresencial.name_user}</Dropdown.Item>
                              <Dropdown.Divider />
                              <Dropdown.Item href="#" onClick={cerrarSesionPresencial}>Cerrar sesión</Dropdown.Item>
                          </Dropdown.Menu>
                      </Dropdown>
                  ) : (
                   
                      <Nav.Link as={Link} to="/votopresencial">
                         {!userAdmin.login &&
                          <div className="icon" style={{fontSize:'30px'}}><i className="bi bi-person-lock"></i></div>
                        }
                      </Nav.Link>
                    
                  )}
              </Navbar.Collapse>
          </Container>
      </Navbar>
  )
}

export default Navbarmenu